import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 100px)',
        display: 'flex',
        overflow: 'hidden',
    },
    main: {
        flexGrow: 1,
        overflowY: 'auto',
        height: 'calc(100vh - 190px)',
        '&::-webkit-scrollbar': {
            display: 'none !important',
         },
        // scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },
    inner: {
        padding: '0px 16px 0px 0px',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
    },

    commentAvatar: {
        height: 24,
        width: 24,
        fontSize: 11,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        backgroundColor: '#5398E6',
        color: '#fff',
      },

      alertRoot: {
        minHeight: 35,            // overall height
        paddingTop: 6,
        paddingBottom: 6,
        alignItems: 'center',
      },
      message: {
        fontSize: 14,             // text size
        lineHeight: 1.3,
      },
      icon: {
        fontSize: 18,             // leading icon size
        marginRight: 8,
      },

    /* Replaced inline styles */
    headerGrid: {
        // height: 88,
        boxSizing: 'border-box',
    },
    headerRow: {
        // marginBottom: 20,
    },
    mainCol: {
        // paddingRight: 20,
    },
    clauseWrap: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },

    /* --------- Responsiveness --------- */
    /* Base (>=1920px) is above. Tweak downwards */
    '@media (max-width:1440px)': {
        main: {
            height: 'calc(100vh - 220px)',
        },
        mainCol: {
            // paddingRight: 18,
        },
        clauseWrap: {
            gap: 20,
        },
    },
    '@media (max-width:1366px)': {
        mainCol: {
            // paddingRight: 16,
        },
        headerGrid: {
            // height: 84,
        },
        headerRow: {
            // marginBottom: 16,
        },
        clauseWrap: {
            gap: 16,
        },
    },
    '@media (max-width:1024px)': {
        // container: {
        //     height: 'calc(100vh - 100px)',
        // },
        headerGrid: {
            // height: 72,
        },
        mainCol: {
            // paddingRight: 12,
        },
        clauseWrap: {
            gap: 12,
        },
    },
    /* --------- Supplemental Comments --------- */
    supplementalWrap: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        marginTop: 20,
        boxSizing: 'border-box',
      },
      emptySupplemental: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 40,
        color: 'rgba(120, 121, 142, 1)',
        fontSize: 14,
        fontStyle: 'normal',
      },
    
      commentCard: {
        minHeight: 70,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        boxSizing: 'border-box',
      },
      commentHeaderRow: {
        height: 24,
        display: 'flex',
        gap: 10,
        justifyContent: 'start',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      commentAvatar: {
        height: 24,
        width: 24,
        fontSize: 11,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        backgroundColor: '#5398E6',
        color: '#fff',
      },
      commentMeta: {
        display: 'flex',
        gap: 6,
        justifyContent: 'center',
        alignItems: 'center',
      },
      commentAuthor: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '21px',
      },
      commentDate: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(120, 121, 142, 1)',
        fontStyle: 'normal',
        lineHeight: '17px',
      },
      commentBodyRow: {
        minHeight: 21,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      commentBodySpacer: {
        minHeight: 34,
        minWidth: 34,
        boxSizing: 'border-box',
      },
      commentText: {
        fontSize: 14,
        fontWeight: 400,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '17px',
        wordBreak: 'break-word',
      },
    
      addCommentRow: {
        minHeight: 110,
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        gap: 10,
        justifyContent: 'start',
        alignItems: 'flex-start',
      },
      addCommentBox: {
        width: '100%',
        paddingRight: 10,
        position: 'relative',
      },
      addCommentTextarea: {
        width: '100%',
        height: 100,
        fontSize: 12,
        resize: 'none',
        outline: 'none',
        borderRadius: 4,
        border: '1px solid rgba(224, 224, 224, 1)',
        background: 'rgba(250, 250, 250, 1)',
        padding: '5px 8px 6px 8px',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
      },
      addCommentButton: {
        height: 26,
        padding: '3px 10px',
        color: '#fff',
        borderRadius: 4,
        position: 'absolute',
        top: 65,
        right: '4%',
        fontSize: 12,
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'rgba(2, 136, 209, 1)',
          borderColor: '#3F51B5',
          boxShadow: 'none',
        },
      },
      addCommentButtonActive: {
        backgroundColor: 'rgba(2, 136, 209, 1)',
      },
      addCommentButtonDisabled: {
        backgroundColor: 'rgba(224, 224, 224, 1)',
      },
      mainGrid: {
        marginTop: '20px',
      },
}));

export default useStyles;